(function () {
  'use strict';

  angular.module('sempraWebapp').factory('totalGivenLocalTokensPerDayReportViewModel', totalGivenLocalTokensPerDayReportViewModelFactory);

  /** @ngInject */
  function totalGivenLocalTokensPerDayReportViewModelFactory(reportActions, localeFilters, reportsFilterStore, $translate, dispatcher, ActionTypesEnum) {
    function totalGivenLocalTokensPerDayReportViewModel() {
      this._reportsFilterStoreChangeHandler = null;
      this.total = 0;
      this.totalByGroupName = [];
      this.chart = {
        data: null,
        chartType: 'bar',
        x: {
          type: 'timeseries',
          tick: {
            culling: { max: 15 },
            rotate: 60,
            format: function (item) {
              return localeFilters.date(item);
            }
          }
        }
      };

      init.call(this);
    }

    totalGivenLocalTokensPerDayReportViewModel.prototype.destroy = function () {
      reportsFilterStore.off(reportsFilterStore.events.CHANGE, this._reportsFilterStoreChangeHandler);
    };

    return totalGivenLocalTokensPerDayReportViewModel;

    function init() {
      var that = this;
      this.isChartVisible = false;

      searchByFilter.call(that);
      this._reportsFilterStoreChangeHandler = function () {
        searchByFilter.call(that);
      };
      reportsFilterStore.on(reportsFilterStore.events.CHANGE, this._reportsFilterStoreChangeHandler);
    }

    function searchByFilter() {
      var that = this,
        reportFilterData = reportsFilterStore.getFilterData();

      that.totalByGroupName = [];

      reportActions.getTotalGivenLocalTokensPerDay(reportFilterData.fromTimestamp, reportFilterData.toTimestamp).then(function (successData) {
        that.total = successData.map(function (item) {
          return item.count;
        }).reduce(function (total, value) {
          return total + value;
        }, 0);
        that.chart.data = successData;
        that.unit = $translate.instant('LOCAL_TOKEN');
        that.isChartVisible = (successData.total !== 0) ? true : false;
        dispatcher.dispatch({
          type: ActionTypesEnum.HIDE_LOADER
        });
      });
    }
  }
})();
